import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Button } from '@/components/ui/button';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen p-6">
          <h2 className="text-2xl font-semibold mb-2 text-foreground">
            Что-то пошло не так
          </h2>
          <p className="text-sm text-muted-foreground mb-4 text-center">
            {this.state.error?.message}
          </p>
          <Button
            onClick={() => window.location.reload()}
            className="mt-2"
          >
            Перезагрузить
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}
